var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { parse } from 'htmlstring-to-react';
import { interpolate, useTranslations } from '.';
var escapeRegex = function (str) { return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'); };
var linkRegex = function (startTag, endTag) {
    return new RegExp(escapeRegex(startTag) + "(.*)" + escapeRegex(endTag), 'g');
};
var addDefaultValues = function (link) { return (__assign({}, link, { start: link.start || '[LINK-BEGIN]', end: link.end || '[LINK-END]' })); };
export var LinkText = function (_a) {
    var id = _a.id, links = _a.links, interpolations = _a.interpolations, tag = _a.tag;
    var _b = __read(useTranslations(), 1), translations = _b[0];
    if (!translations[id]) {
        console.error("Couldn't find '" + id + "' in the translations table"); // eslint-disable-line no-console
        return null;
    }
    var translated = translations[id];
    var overrides = {};
    links.map(addDefaultValues).map(function (link, index) {
        var regexp = linkRegex(link.start, link.end);
        var key = "link-text-" + index;
        var props = {
            className: link.class || link.className,
            href: link.href,
            id: link.id,
            key: key,
            target: link.target,
            onClick: link.onClick,
        };
        Object.keys(props).forEach(function (key) { return typeof props[key] === 'undefined' && delete props[key]; });
        overrides["a[key=\"" + key + "\"]"] = function (_, textContent) { return (React.createElement("a", __assign({}, props), interpolations ? interpolate(textContent, interpolations, tag) : textContent)); };
        function insertTag(match) {
            var textContent = match.substring(link.start.length, match.length - link.end.length);
            return "<a key=\"" + key + "\">" + textContent + "</a>";
        }
        translated = translated.replace(regexp, insertTag);
        return translated;
    });
    return (React.createElement(React.Fragment, null, parse(translated, {
        dom: {
            ADD_ATTR: ['target', 'key'],
        },
        overrides: overrides,
    }).reduce(function (arr, item) {
        return arr.concat(typeof item === 'string' && interpolations
            ? interpolate(item, interpolations, tag)
            : [item]);
    }, [])));
};
//# sourceMappingURL=linkText.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ilenia/dist/linkText.js
// module id = 579
// module chunks = 0